import { theme } from '@chakra-ui/react'

export const sizes = {
  ...theme.sizes,
  'admin-header-height': '4.5rem',
  'event-header-height': '4rem',
  'admin-content-min-height': 'calc(100vh - 32px - 4.5rem)',
}
